export type InvestigationStatus = 'queued' | 'running' | 'completed' | 'failed';

// Shared with the AI settings contract, so a model the settings can pick is one a run can report.
export type AiProvider = 'anthropic' | 'openai' | 'openrouter';
export type AiEffort = 'low' | 'medium' | 'high' | 'xhigh' | 'max';

export interface InvestigationAction {
  title: string;
  detail: string;
  kind: 'resolve' | 'investigate';
}

export interface InvestigationStep {
  tool: string;
  args: unknown;
  resultPreview: string;
  startedAt: string;
  durationMs: number;
  isError: boolean;
}

export interface Investigation {
  _id: string;
  ticketId: string;
  status: InvestigationStatus;
  // Unset until the worker's triage step resolves the tier — any run that fails or
  // stalls before that point has none of these three.
  model?: { provider: AiProvider; id: string };
  effort?: AiEffort;
  maxSteps?: number;
  result?: { summary: string; actions: InvestigationAction[]; confidence: number; draftReply: string } | null;
  debug?: {
    systemPrompt?: string;
    contextSummary?: string;
    toolCatalog?: string[];
    steps?: InvestigationStep[];
    reasoning?: string;
    rawOutput?: string;
    usage?: { inputTokens: number; outputTokens: number; estimatedCost: number | null };
  } | null;
  error?: string | null;
  startedAt?: string | null;
  completedAt?: string | null;
  lastProgressAt?: string | null;
  createdAt: string;
}

export interface InvestigationListResponse {
  data: Investigation[];
}

// 180_000 must match STALE_AFTER_MS in supportTicket.investigate.ts — the API
// auto-expires runs past this on the next investigate POST, so Re-run works.
// Queued counts as well as running: the API expires both, and a run the worker
// never claimed would otherwise poll as live forever with no way to re-run it.
export function isStale(inv: Investigation): boolean {
  return (inv.status === 'running' || inv.status === 'queued') && Date.now() - Date.parse(inv.lastProgressAt ?? inv.createdAt) > 180_000;
}
